export default "/images/vendor/flag-icons/flags/4x3/ir.svg?abc2de236d65d0587f0084e6c873ac3f";